import React, { useEffect, useState } from 'react';
import { jsDictionaryEquals } from '../../../../../../../../ressources/functionJS/jsDictionaryEquals';
import Collapse from '../../../../../../../../hoc/Collapse/Collapse';
import FormulaireListesObjetsRapport from '../../FormulaireListeObjetsRapport';
import styles from './SectionRapport.module.scss';

const SectionRapport = ({
  preconfigureObjet,
  gererJson,
  contenuEnTete,
  affichageProfil,
  project_id,
  children,
}) => {
  // Split state into multiple useState hooks
  const [sectionName, setSectionName] = useState(
    preconfigureObjet?.section_name || ''
  );
  const [objectsList, setObjectsList] = useState(
    preconfigureObjet?.objects_list || []
  );
  const [reportObjectType, setReportObjectType] = useState(
    preconfigureObjet?.report_object_type || ''
  );

  // Effect to handle preconfigureObjet changes
  useEffect(() => {
    if (preconfigureObjet === undefined) {
      // Reset to default values
      setSectionName('');
      setObjectsList([]);
      setReportObjectType('');
    } else {
      // Update with new preconfigured values
      setSectionName(preconfigureObjet.section_name || '');
      setObjectsList(preconfigureObjet.objects_list || []);
      setReportObjectType(preconfigureObjet.report_object_type || '');
    }
  }, [preconfigureObjet]); // Effect to notify parent of state changes
  useEffect(() => {
    const currentState = {
      section_name: sectionName,
      objects_list: objectsList,
      report_object_type: reportObjectType,
    };
    if (!jsDictionaryEquals(currentState, preconfigureObjet) && gererJson) {
      gererJson(currentState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionName, objectsList, reportObjectType]);

  // Event handlers
  const handleSectionNameChange = (event) => {
    setSectionName(event.target.value);
  };

  const handleObjectsList = (newObjectsList) => {
    setObjectsList([...newObjectsList]);
  };

  return (
    <Collapse
      showAdvanceParameters={true}
      expandText={
        <div className={styles.contenuEnTete}>
          {contenuEnTete}
          <span className={styles.titre}>{sectionName}</span>
        </div>
      }
    >
      {children}
      <input
        className={styles.Input}
        type="section_name"
        name="section_name"
        value={sectionName}
        disabled={affichageProfil === true}
        onChange={handleSectionNameChange}
      />
      <FormulaireListesObjetsRapport
        project_id={project_id}
        gererObjectsList={handleObjectsList}
        objects_list={objectsList}
        affichageProfil={affichageProfil}
        typeObjetParent={reportObjectType}
      />
    </Collapse>
  );
};

export default SectionRapport;
